<template>
  <div id="app">
    <Header></Header>
    <router-view />
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
  export default {
    name: "App",
    created() {
      window.scrollTo(0, 0)
    },
    updated() {
      window.scrollTo(0, 0)
      // document.getElementById("app").scrollTop = 0
    },
    watch: {
      $route(to, from) {
        window.scrollTo(0, 0)
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue